import { Card } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Trash2, Plus } from 'lucide-react';

const TestimonialsEditor = ({ data, setData }) => {
  const items = data.items || [];
  const update = (newItems) => setData({ ...data, items: newItems });

  return (
    <div className="space-y-4">
      {items.map((item, i) => (
        <Card key={i} className="p-4">
          <div className="flex items-start gap-3">
            <div className="flex-1 space-y-2">
              <div className="grid grid-cols-2 gap-2">
                <Input value={item.name || ''} onChange={e => { const n = [...items]; n[i] = { ...n[i], name: e.target.value }; update(n); }} placeholder="الاسم" data-testid={`test-name-${i}`} />
                <Input value={item.role || ''} onChange={e => { const n = [...items]; n[i] = { ...n[i], role: e.target.value }; update(n); }} placeholder="الصفة (مثال: قارئ)" data-testid={`test-role-${i}`} />
              </div>
              <textarea value={item.text || ''} onChange={e => { const n = [...items]; n[i] = { ...n[i], text: e.target.value }; update(n); }} placeholder="نص الشهادة..."
                className="w-full border rounded-lg p-2 text-sm min-h-[60px] resize-none focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none" data-testid={`test-text-${i}`} />
            </div>
            <button onClick={() => update(items.filter((_, j) => j !== i))} className="text-red-400 hover:text-red-600 mt-2"><Trash2 className="w-5 h-5" /></button>
          </div>
        </Card>
      ))}
      <Button variant="outline" onClick={() => update([...items, { name: '', role: '', text: '' }])} className="w-full" data-testid="add-testimonial">
        <Plus className="w-4 h-4 ml-2" /> إضافة شهادة
      </Button>
    </div>
  );
};

export default TestimonialsEditor;
